<template>
    <v-client-table
        class="dataTable" md="12" lg="12" sm="12"
        :columns="columns"
        :data="activities"
        :options="options"
        :theme="theme" >

        <template slot="registered" slot-scope="props">
            <span v-if="props.row.registered">{{props.row.registered | dateFormat('DD/MM/YYYY')}}</span>
        </template>

    </v-client-table>
</template>

<script>
    import Vue from 'vue';
    import {ClientTable} from 'vue-tables-2';
    import form from '@/helpers/form';
    import {getUsersActivity} from '@/api/activity-api';

    Vue.use(ClientTable);

    export default {

        name: 'LastActivity',
        components: {
            ClientTable,
        },

        data: function () {
            return {
                activities: [],
                columns: ['username', 'description', 'registered'],
                options: {
                    headings: {
                        username: 'Usuario',
                        description: 'Detalle',
                        registered: 'Fecha',
                    },
                    filterable: ['username', 'description', 'registered'],
                    texts: null,
                    pagination: {
                        chunk: 5,
                        edge: true,
                        nav: 'scroll'
                    }
                },
                useVuex: false,
                theme: 'bootstrap4',
                template: 'default',
            }
        },

        mounted(){
            this.options.texts = form.tableLabels();
            this.getLastActivity();
        },

        methods: {

            async getLastActivity(){

                this.$_loadingMixin_showLoading();

                await getUsersActivity()
                    .then((activities) => {
                        this.activities = activities;
                    });

                this.$_loadingMixin_hideLoading();
            },
        },
    }
</script>